import { Component } from 'react';
import { connect } from 'react-redux';

import { checkDifferent } from 'utils/formHandlers';

import { formatNumberWithCommas, metersToKilometers, metersToNauticalMiles } from 'utils/unit';
import { CoordinateArray, RootState } from '../../types';

interface MeasurePositionProps {
    coordinate: CoordinateArray | null;
    hoverMeasureData: any | null;
}

interface MeasurePositionState {
    coordinate: [];
    hoverMeasureData: any | null;
}

class MeasurePosition extends Component<MeasurePositionProps, MeasurePositionState> {
    constructor(props: MeasurePositionProps) {
        super(props);
        this.state = {
            coordinate: [],
            hoverMeasureData: null,
        };
    }

    static getDerivedStateFromProps(props: MeasurePositionProps, state: MeasurePositionState) {
        if (
            checkDifferent(props.coordinate, state.coordinate) ||
            checkDifferent(props.hoverMeasureData, state.hoverMeasureData)
        ) {
            return {
                coordinate: props.coordinate,
                hoverMeasureData: props.hoverMeasureData,
            };
        }

        return null;
    }

    render() {
        return (
            <>
                {this.state.hoverMeasureData?.length && this.state.coordinate && (
                    <div
                        className="fixed bg-white px-2 z-100 overflow-hidden rounded-md text-sm py-1"
                        style={{ left: this.state.hoverMeasureData.x, top: this.state.hoverMeasureData.y }}
                    >
                        <div className="">
                            {formatNumberWithCommas(
                                metersToNauticalMiles(this.state.hoverMeasureData.length).toFixed(2)
                            )}{' '}
                            NM (
                            {this.state.hoverMeasureData.length > 1000
                                ? formatNumberWithCommas(
                                      metersToKilometers(this.state.hoverMeasureData.length).toFixed(1)
                                  )
                                : formatNumberWithCommas(this.state.hoverMeasureData.length.toFixed(0))}
                            {this.state.hoverMeasureData.length > 1000 ? ' km' : ' m'}) @
                            {parseFloat(this.state.hoverMeasureData.bearing.toFixed(1))}°
                        </div>
                    </div>
                )}
            </>
        );
    }
}

const measurePositionStateToProps = (state: RootState) => ({
    openMenu: state.layout.layout.openMenu,
    openTool: state.layout.layout.openTool,
});

const measurePositionDispatchToProps = () => ({});

export default connect(measurePositionStateToProps, measurePositionDispatchToProps)(MeasurePosition);
